<template>
  <div>
    <Sidebar
      v-model="showSidebar"
      :main-title="sidebarTitle"
      :list="sidebarList"
      :main-avatar-image="sidebarAvatarImage"
      :main-avatar-icon="sidebarAvatarIcon"
    />
    <VAppBar
      color="primary"
    >
      <VAppBarNavIcon
        :onclick="onAppBarNavIconClick"
      />
      <slot name="CenterContent" >
        <VToolbarTitle>{{ c_HeaderTitle }}</VToolbarTitle>
      </slot>
      <VSpacer />

      <slot name="RightContent" />
      <UserActions>
        <template #UserActions>
          <slot name="UserActions" />
        </template>
      </UserActions>
    </VAppBar>
    <VMain>
      <RouterView />
    </VMain>
    <VFooter
      v-if="showFooter"
      app
      dark
      :color="headerColor"
    >
      {{ footerText }}
    </VFooter>
  </div>
</template>

<script>
import UserActions from '@/components/layouts/Header/UserActions'
import Sidebar from '@/components/layouts/Sidebar/Sidebar'
import BUSINESS_DATA from '@/configs/businessConstants'
import { mapGetters } from 'vuex'

export default {
  components: {
    UserActions,
    Sidebar
  },
  props: {
    sidebarTitle: {
      type: String,
      default: BUSINESS_DATA.APP_TITLE
    },
    sidebarList: {
      type: Array,
      default: () => [
        {
          title: 'Section_1',
          items: [
            {
              title: 'Child_1.1',
              icon: 'mdi-view-dashboard',
              to: { name: '' },
              child: [
                {
                  title: 'Grandchild_1.1.1',
                  icon: 'mdi-view-dashboard',
                  to: { name: '' },
                }
              ]
            }
          ]
        }
      ]
    },
    sidebarAvatarIcon: {
      type: String,
      default: 'mdi-vuetify'
    },
    sidebarAvatarImage: {
      type: String,
      default: require('@/assets/images/favicon.png')
    },
    footerText: {
      type: String,
      default: BUSINESS_DATA.APP_FOOTER
    },
  },
  data () {
    return {
      showSidebar: false
    }
  },
  mounted () {
    this.showSidebar = this.$vuetify.display.mobile ? false : true
  },
  computed: {
    ...mapGetters('App', [
      'getAppHeaderTitle',
      'getAppHeaderColor',
      // 'getAppDocumentTitle',
      // 'getAppFullScreen'
    ]),
    c_HeaderTitle () {
      return this.getAppHeaderTitle ?? this.$route.name
    },
    headerColor () {
      return this.getAppHeaderColor ?? 'primary'
    },
    showFooter () {
      //  use router meta
      return this.$route.meta.showFooter ?? true
    },
  },
  methods: {
    onAppBarNavIconClick () {
      this.showSidebar = !this.showSidebar
    }
  }
}
</script>
